import { render, staticRenderFns } from "./IdleNotification.vue?vue&type=template&id=72bbbd11"
import script from "./IdleNotification.vue?vue&type=script&lang=js"
export * from "./IdleNotification.vue?vue&type=script&lang=js"
import style0 from "./IdleNotification.vue?vue&type=style&index=0&id=72bbbd11&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports